import { render, staticRenderFns } from "./contractDetailChange.vue?vue&type=template&id=21c73d50&scoped=true"
import script from "./contractDetailChange.vue?vue&type=script&lang=js"
export * from "./contractDetailChange.vue?vue&type=script&lang=js"
import style0 from "./contractDetailChange.vue?vue&type=style&index=0&id=21c73d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c73d50",
  null
  
)

export default component.exports